import {Injectable, signal} from '@angular/core';
import {NonNullableFormBuilder} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import moment from 'moment';
import {ErpOutboundPanelFilterForm, ErpOutboundPanelFilterModel} from '../models/erp-outbound-panel-filter-model';

/**
 * Holds the single page-level filter for the ERP Outbound Report dashboard.
 * The navbar flips <see cref="toggleModal"/> to open the filter modal; the modal
 * calls setFilters(); the grid's GridGetService reads filtersValue().
 * Defaults to the last one week (today - 7 days -> today).
 */
@Injectable({
  providedIn: 'root'
})
export class ErpOutboundPanelFilterService {
  public readonly toggleModal = signal(false);

  public readonly filtersValue = signal<ErpOutboundPanelFilterModel>(this.buildDefaultFilters());

  private readonly filters$ = new BehaviorSubject<ErpOutboundPanelFilterModel>(this.filtersValue());

  public get form(): ErpOutboundPanelFilterForm {
    return this.formBuilder.group({
      InvoiceNumber: [null as string | null],
      PNR: [null as string | null],
      ErpMessageId: [null as string | null],
      ErpOrderNumber: [null as string | null],
      LegalEntityId: [null as number | null],
      QueueName: [null as string | null],
      ResponseType: [null as string | null],
      Result: [null as string | null],
      CreatedDateFrom: [null as Date | null],
      CreatedDateTo: [null as Date | null],
      AdxInvoiceId: [null as number | null],
      HasSalesOrderNumber: [null as boolean | null],
      HasAdxInvoiceId: [null as boolean | null]
    });
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {}

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: ErpOutboundPanelFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }

  public buildDefaultFilters(): ErpOutboundPanelFilterModel {
    return {
      InvoiceNumber: null,
      PNR: null,
      ErpMessageId: null,
      ErpOrderNumber: null,
      LegalEntityId: null,
      QueueName: null,
      ResponseType: null,
      Result: null,
      CreatedDateFrom: moment().subtract(7, 'days').startOf('day').toDate(),
      CreatedDateTo: moment().endOf('day').toDate(),
      AdxInvoiceId: null,
      ReloadGrid: false,
      HasSalesOrderNumber: true,
      HasAdxInvoiceId: null
    };
  }
}
